export const locale = {
    lang: 'pl',
    data: {
        'Delete': 'Usuń',
        'Edit': 'Edytuj'
    }
};
